export enum ESin {
  Envy = 'envy',
  Gluttony = 'gluttony',
  Greed = 'greed',
  Lust = 'lust',
  Pride = 'pride',
  Sloth = 'sloth',
  Wrath = 'wrath'
}

export const sins = [
  ESin.Envy,
  ESin.Gluttony,
  ESin.Greed,
  ESin.Lust,
  ESin.Pride,
  ESin.Sloth,
  ESin.Wrath
]
